module.exports = __webpack_public_path__ + "img/icon_caret_.69c16352.svg";